/* global __SENTRY_RELEASE__ */
import * as Sentry from '@sentry/vue';

/**
 * Initialize Sentry for the website browser bundle.
 *
 * Call once from the Inertia createInertiaApp setup() with the Vue app instance.
 * Becomes a no-op when MIX_SENTRY_DSN is empty so local dev / no-token environments
 * never attempt network calls.
 */
export function initSentry(app) {
    const dsn = process.env.MIX_SENTRY_DSN;
    if (!dsn) {
        // No DSN configured — silently skip init. Required for local dev and for
        // builds that don't want browser telemetry (e.g., previews).
        return;
    }

    const release =
        (typeof __SENTRY_RELEASE__ !== 'undefined' && __SENTRY_RELEASE__) ||
        'unknown';

    // MIX_APP_ENV is not standard; prefer the Laravel-exposed APP_ENV via the
    // MIX_ prefix if available, else fall back to NODE_ENV for the build context.
    const environment =
        process.env.MIX_APP_ENV ||
        process.env.NODE_ENV ||
        'production';

    Sentry.init({
        app,
        dsn,
        environment,
        release,
        // Conservative defaults — Phase 15 can dial up tracesSampleRate when
        // alerting/performance is wired up. Right now we want error capture only.
        tracesSampleRate: 0,
        // Attach Vue component tree context to errors without spamming breadcrumbs.
        trackComponents: true,
        logErrors: true,
    });
}
